const poundsToKg = (pounds:number) => pounds / 2.2
const inchesToCm  = (inches:number) => inches * 2.54
const cmToM = (cm:number) => cm / 100

export {
    poundsToKg,
    inchesToCm,
    cmToM
}